import { frontendURL } from 'dashboard/helper/URLHelper';

const AppointmentsIndex = () => import('./pages/AppointmentsIndex.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/appointments'),
      name: 'appointments_index',
      component: AppointmentsIndex,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
